module.exports = __webpack_public_path__ + "img/map_pin_home2.e3a1b6b5.svg";